import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { EffectsModule } from '@ngrx/effects';

import { AgGridModule } from '@ag-grid-community/angular';
import { InventoryService } from '@inventory/inventory.service';
import { InventoryEffects } from '@inventory/store/inventory.effects';

import { ModalDialogComponent } from './dialogs/modal-dialog/modal-dialog.component';
import { CopyrightComponent } from './footer/copyright/copyright.component';
import { VersionComponent } from './footer/version/version.component';
import { LoadingIndicatorComponent } from './header/loading-indicator/loading-indicator.component';
import { MenuComponent } from './header/menu/menu.component';
import { ScreenTitleComponent } from './header/screen-title/screen-title.component';
import { ColumnPreferencesComponent } from './screen-components/column-preferences/column-preferences.component';
import { ExportComponent } from './screen-components/export/export.component';
import { FieldLabelComponent } from './screen-components/field-label/field-label.component';
import { GridHelpComponent } from './screen-components/grid-help/grid-help.component';
import { GridMenuComponent } from './screen-components/grid-menu/grid-menu.component';
import { LoaderSpinnerComponent } from './screen-components/loader-spinner/loader-spinner.component';
import { ModalLoadingIndicatorComponent } from './screen-components/modal-loading-indicator/modal-loading-indicator.component';
import { RequiredFieldComponent } from './screen-components/required-field/required-field.component';
import { WebSynapseComponent } from './websynapse/web-synapse.component';
import { WelcomeScreenComponent } from './welcome-screen/welcome-screen.component';

import { ChangeCustomerDialogComponent } from '../auth/dialogs/change-customer-dialog/change-customer-dialog.component';
import { ChangeCustomerFilterComponent } from '../auth/dialogs/change-customer-dialog/change-customer-filter/change-customer-filter.component';
import { ChangeCustomerGridComponent } from '../auth/dialogs/change-customer-dialog/change-customer-grid/change-customer-grid.component';
import { ChangeCustomerScreenComponent } from '../auth/dialogs/change-customer-dialog/change-customer-screen/change-customer-screen.component';
import { ChangeFacilityDialogComponent } from '../auth/dialogs/change-facility-dialog/change-facility-dialog.component';
import { ChangeFacilityFilterComponent } from '../auth/dialogs/change-facility-dialog/change-facility-filter/change-facility-filter.component';
import { ChangeFacilityGridComponent } from '../auth/dialogs/change-facility-dialog/change-facility-grid/change-facility-grid.component';
import { ChangeFacilityScreenComponent } from '../auth/dialogs/change-facility-dialog/change-facility-screen/change-facility-screen.component';
import { SessionTimeoutDialogComponent } from '../auth/dialogs/session-timeout-dialog/session-timeout-dialog.component';
import { SharedModule } from './shared.module';

@NgModule({
  declarations: [
    MenuComponent,
    WelcomeScreenComponent,
    ScreenTitleComponent,
    LoadingIndicatorComponent,
    WebSynapseComponent,
    ExportComponent,
    ColumnPreferencesComponent,
    ModalLoadingIndicatorComponent,
    RequiredFieldComponent,
    FieldLabelComponent,
    GridMenuComponent,
    GridHelpComponent,
    ModalDialogComponent,
    ChangeFacilityDialogComponent,
    ChangeCustomerDialogComponent,
    ChangeCustomerGridComponent,
    ChangeCustomerScreenComponent,
    LoaderSpinnerComponent,
    ChangeCustomerFilterComponent,
    ChangeFacilityScreenComponent,
    ChangeFacilityGridComponent,
    ChangeFacilityFilterComponent,
    SessionTimeoutDialogComponent,
    VersionComponent,
    CopyrightComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    AgGridModule,
    FormsModule,
    ReactiveFormsModule,
    EffectsModule.forFeature([InventoryEffects]),
    SharedModule,
  ],
  exports: [
    MenuComponent,
    ScreenTitleComponent,
    LoadingIndicatorComponent,
    ColumnPreferencesComponent,
    ModalLoadingIndicatorComponent,
    RequiredFieldComponent,
    FieldLabelComponent,
    GridMenuComponent,
    GridHelpComponent,
    ModalDialogComponent,
    ExportComponent,
    LoaderSpinnerComponent,
    SessionTimeoutDialogComponent,
  ],
  providers: [InventoryService],
})
export class MainModule {}
